import * as types from "./types";

// Evaluation rounds
export const getCompanyEvaluationsRequest = (payload) => ({
  type: types.GET_COMPANY_EVALUATIONS_REQUEST,
  payload,
});

export const getCompanyEvaluationsResponse = (payload) => ({
  type: types.GET_COMPANY_EVALUATIONS_RESPONSE,
  payload,
});

export const createCompanyEvaluationRequest = (payload) => ({
  type: types.CREATE_COMPANY_EVALUATION_REQUEST,
  payload,
});

export const updateCompanyEvaluationRequest = (payload) => ({
  type: types.UPDATE_COMPANY_EVALUATION_REQUEST,
  payload,
});

// Evaluation forms
export const getCompanyEvaluationFormsRequest = (payload) => ({
  type: types.GET_COMPANY_EVALUATION_FORMS_REQUEST,
  payload,
});

export const getCompanyEvaluationFormsResponse = (payload) => ({
  type: types.GET_COMPANY_EVALUATION_FORMS_RESPONSE,
  payload,
});

export const getCompanyEvaluationFormRequest = (payload) => ({
  type: types.GET_COMPANY_EVALUATION_FORM_REQUEST,
  payload,
});

export const getCompanyEvaluationFormResponse = (payload) => ({
  type: types.GET_COMPANY_EVALUATION_FORM_RESPONSE,
  payload,
});

export const submitCompanyEvaluationFormRequest = (payload) => ({
  type: types.SUBMIT_COMPANY_EVALUATION_FORM_REQUEST,
  payload,
});

export const submitCompanyEvaluationFormResponse = (payload) => ({
  type: types.SUBMIT_COMPANY_EVALUATION_FORM_RESPONSE,
  payload,
});
